import Loading from './Loading';

export default Loading;



// WEBPACK FOOTER //
// ./src/client/Components/Loading/index.js